import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '11.78 11.3087'
  const rightTransformOrigin = '45.05 11.3087 '

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M24.55 9.20871L0 11.2987C0 11.2987 6.38999 5.35869 7.59999 4.46869C8.80999 3.58869 23.23 4.3587 23.23 4.3587L24.55 9.20871Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M23.56 5.4687C23.56 5.4687 9.46999 3.81872 7.92999 4.36872C6.38999 4.91872 0 11.3087 0 11.3087C0 11.3087 6.38999 1.61872 7.59999 0.738717C8.80999 -0.141283 22.24 0.628702 22.24 0.628702L23.56 5.4687Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M32.2002 9.20871L56.8302 11.2987C56.8302 11.2987 50.4402 5.35869 49.2302 4.46869C48.0202 3.58869 33.5102 4.3587 33.5102 4.3587L32.2002 9.20871Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M33.27 5.4687C33.27 5.4687 47.36 3.81872 48.9 4.36872C50.44 4.91872 56.83 11.3087 56.83 11.3087C56.83 11.3087 50.44 1.61872 49.23 0.738717C48.02 -0.141283 34.59 0.628702 34.59 0.628702L33.27 5.4687Z"
          fill={fill}
        />

        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="44.5153"
            y1="12.5528"
            x2="44.5153"
            y2="5.9628"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="12.2751"
            y1="12.5528"
            x2="12.2751"
            y2="5.9628"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
